import { useUserTags } from '~features/tags/useUserTags';
import { useShopQuery } from '~services/api/credits';

export const useShop = () => {
	const { isSuccess: tagsSuccess } = useUserTags();

	const { data, isLoading, isSuccess } = useShopQuery(undefined, {
		skip: !tagsSuccess,
		refetchOnMountOrArgChange: 15 * 60, // 15 min
	});
	return { data, isLoading, isSuccess };
};
